module.exports = __webpack_public_path__ + "static/media/logo_PSOE-A.578c78b5.svg";